import React, { useEffect, useState, useContext } from "react";
import { Context } from "../../context/Context";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

const UserPayments = () => {
  const { token } = useContext(Context);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // Stan dla bieżącej strony
  const [itemsPerPage] = useState(3); // Ilość płatności na stronę
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchPayments = async () => {
      if (!token) {
        setError("No token found. Please log in.");
        setLoading(false);
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        const userId = decodedToken._id;

        const response = await axios.get(
          `${BACKEND_URL}/api/payment/getUserPayments/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setPayments(response.data);
      } catch (err) {
        setError(
          `An error occurred while fetching payments. ${
            err.response?.data?.message || err.message || "Unknown error"
          }`
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
  }, [token]);

  // Paginacja
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = payments.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const renderPaymentInfo = (payment) => {
    const karnet = payment.karnet_id;
    if (!karnet) return "Brak danych karnetu";

    if (karnet.platnosc_rodzaj === "rata") {
      return (
        <div className="space-y-1">
          <p>
            <span className="font-medium">Karnet:</span> {karnet.nazwa}
          </p>
          <p>
            <span className="font-medium">Rata:</span> {payment.kwota} PLN
          </p>
          <p>
            <span className="font-medium">Opłacono:</span>{" "}
            {karnet.karnet_oplacone} PLN
          </p>
          <p>
            <span className="font-medium">Zostało </span> {karnet.ilosc_rat} rat
          </p>
        </div>
      );
    } else {
      return (
        <div className="space-y-1">
          <p>
            <span className="font-medium">Karnet:</span> {karnet.nazwa}
          </p>
          <p>
            <span className="font-medium">Całkowita cena karnetu:</span>{" "}
            {karnet.cena} PLN
          </p>
          <p>
            <span className="font-medium">Opłacono:</span>{" "}
            {karnet.karnet_oplacone} PLN
          </p>
        </div>
      );
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-lg font-medium text-gray-600">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-lg font-medium text-red-600">{error}</div>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto bg-white rounded-lg shadow-md p-8">
      <h2 className="text-3xl font-bold text-gray-800 text-center mb-6">
        Historia Płatności
      </h2>
      {payments.length === 0 ? (
        <p className="text-center text-gray-600 text-lg">
          Brak historii płatności.
        </p>
      ) : (
        <div>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {currentItems.map((payment) => (
              <div
                key={payment._id}
                className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="mb-3 pb-2 border-b border-gray-200">
                  <p className="text-sm text-gray-500">
                    Data płatności:{" "}
                    {new Date(payment.data_platnosci).toLocaleDateString()}
                  </p>
                </div>
                {renderPaymentInfo(payment)}
              </div>
            ))}
          </div>
          {/* Paginacja */}
          <div className="flex justify-center mt-6">
            {Array.from(
              { length: Math.ceil(payments.length / itemsPerPage) },
              (_, i) => (
                <button
                  key={i + 1}
                  onClick={() => paginate(i + 1)}
                  className={`mx-1 px-3 py-1 rounded ${
                    currentPage === i + 1
                      ? "bg-blue-600 text-white"
                      : "bg-gray-200"
                  }`}
                >
                  {i + 1}
                </button>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default UserPayments;
